import React from 'react';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';

import { PrematchPage } from '../Prematch';
import { PrematchPageWS } from '../PrematchWS';

export const PrematchSwitchRoute = () => {
  const isPrematchWS = useFeatureFlag(FeatureFlag.PREMATCH_WS);

  return isPrematchWS ? <PrematchPageWS /> : <PrematchPage />;
};
